import React, { useState, useEffect } from 'react';
import BarraRicercaOrdini from './DBperAreaOrdiniComponenti/BarraRicercaOrdini';

import ListaOrdini from './DBperAreaOrdiniComponenti/ListaOrdini';

function DBperAreaContabili({
    ordine,
    setOrdineFunction,
    urlRicerca,
    setUrlRicerca,
    limiteRighe,
    setLimiteRighe,
    setResImport,
    totalRows,
    setTotalRows,
    perPage,
    setPerPage,
    page,
    setPage,
    urlParametri,
    setUrlParametri,
    datiTendineOrdine,
    ricerca,
    tema,
    utente,
    selezioneCampiRicerca,
    inputIniziale,
    setInputIniziale,
    vista,
    columnSort,
    setColumnSort,
    directionSort,
    setDirectionSort,
    fetchOrdini,
    handlePageChange,
    handlePerRowsChange,
    handleSort,
    setRigheSelezionate,
    righeSelezionate,
    data,
    loading,
    deseleziona,
    setDeseleziona,
    setData,
    setRicerca,
    inputVuoto,
    perPageOptions,
    setVista,
    urlRicercaINIT,
    ricercaIniz,
    mobile,
    setLoading,
    setListeOrdiniDaAltrove,
    setVistaConReset
}) {


    useEffect(() => {
        fetchOrdini(page);
    }, [vista]);



    return (
        <div class="center">
            <div class="cf contentSubSubHeader ">
                <div class="fl-ns w-100 w-100-ns w-100-m w-100-l pr4 pl3 bb bordoColAlt sfondoBiancoTema">
                    {mobile && righeSelezionate.length < 1 && <BarraRicercaOrdini
                        vista={"mobile2"}
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        setInputIniziale={setInputIniziale}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        ricerca={ricerca}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={false}
                        setLoading={setLoading}
                        setPage={setPage}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        fetchOrdini={fetchOrdini}
                    />}
                    {righeSelezionate.length < 1 && <BarraRicercaOrdini
                        vista={vista}
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        setInputIniziale={setInputIniziale}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        ricerca={ricerca}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={mobile}
                        setLoading={setLoading}
                        setPage={setPage}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        fetchOrdini={fetchOrdini}
                    />}
                </div>
                <div class="fl-ns w-100 w-100-ns pr3 pl4 sfondoBiancoTema">
                    <ListaOrdini
                        vista={vista}
                        setOrdineFunction={setOrdineFunction}
                        listaOrdini={data}
                        setListaOrdini={setData}
                        righeSelezionate={righeSelezionate}
                        setRigheSelezionate={setRigheSelezionate}
                        loading={loading}
                        totalRows={totalRows}
                        handlePerRowsChange={handlePerRowsChange}
                        handlePageChange={handlePageChange}
                        perPage={perPage}
                        deseleziona={deseleziona}
                        utente={utente}
                        handleSort={handleSort}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        perPageOptions={perPageOptions}
                        ricerca={ricerca}
                        page={page}
                        setVistaConReset={setVistaConReset}
                    />
                </div>
            </div>
        </div>

    )
}


export default DBperAreaContabili;
